import { useState } from 'react'
import { STATUSES, updateLeadStatus } from '../api/leadService'
/* Lead status control + status update UI (validation, loading, success, error) */
export default function LeadStatusControl({ lead, onUpdated }) {
  const [value, setValue] = useState(lead.status)
  const [ui, setUi] = useState({ state: 'idle', msg: '' })
  const save = async () => {
    if (value === lead.status) return setUi({ state: 'invalid', msg: 'Choose a different status to update.' })
    setUi({ state: 'loading', msg: '' })
    try { const l = await updateLeadStatus(lead.id, value); setUi({ state: 'success', msg: `Status updated to ${value}.` }); onUpdated(l) }
    catch { setUi({ state: 'error', msg: 'Could not update status. Try again.' }) }
  }
  const cls = { invalid: 'warning', success: 'success', error: 'danger' }[ui.state]
  return (<div className="card"><div className="card-body"><h6 className="mb-3">Status</h6>
    <select className="form-select mb-2" value={value} onChange={e => { setValue(e.target.value); setUi({ state: 'idle', msg: '' }) }}>{STATUSES.map(s => <option key={s}>{s}</option>)}</select>
    <button className="btn btn-primary w-100" disabled={ui.state === 'loading'} onClick={save}>{ui.state === 'loading' ? 'Updating…' : 'Update Status'}</button>
    {cls && <div className={`alert alert-${cls} py-2 mt-2 mb-0 small`}>{ui.msg}</div>}</div></div>)
}
